import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS, SUPPORT_EMAIL, HELP_CENTER_PATH, CONTACT_PATH } from '../../constants/siteNav';
import BrandLogo from '../brand/BrandLogo';

const SiteFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <BrandLogo size="md" imgClassName="rounded-lg shadow-sm" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Kenya&apos;s ticketing platform for concerts, conferences, festivals, and experiences across Africa.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Discover</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/events" className="hover:text-orange-400 transition-colors">Browse events</Link></li>
              <li><Link to="/categories" className="hover:text-orange-400 transition-colors">Categories</Link></li>
              <li><Link to="/about" className="hover:text-orange-400 transition-colors">About us</Link></li>
              <li><Link to={HELP_CENTER_PATH} className="hover:text-orange-400 transition-colors">Help center</Link></li>
              <li><Link to={CONTACT_PATH} className="hover:text-orange-400 transition-colors">Contact us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Organizers</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/admin/events/create" className="hover:text-orange-400 transition-colors">List your event</Link></li>
              <li>
                <Link to={HELP_CENTER_PATH} className="hover:text-orange-400 transition-colors">
                  Organizer support
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Legal &amp; connect</h3>
            <ul className="space-y-2 text-sm mb-4">
              <li><Link to="/terms-of-service" className="hover:text-orange-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-orange-400 transition-colors">Privacy Policy</Link></li>
              <li>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-orange-400 transition-colors">
                  {SUPPORT_EMAIL}
                </a>
              </li>
            </ul>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-md bg-gray-800 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-colors text-gray-400"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>&copy; {year} Niko Vibe. All rights reserved.</p>
          <p>Secure ticketing · Instant delivery · M-Pesa ready</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
